import React, { useEffect, useState } from "react";
import "../../styles/serviceCallStyles/ServiceSummary.css";

// Utility function for retrieving data from localStorage
const getFromLocalStorage = (key, defaultValue) => {
  const storedValue = localStorage.getItem(key);
  return storedValue ? JSON.parse(storedValue) : defaultValue;
};

const ServiceSummary = () => {
  const [projectDescription, setProjectDescription] = useState(() =>
    getFromLocalStorage("serviceData", {})
  );
  const [tasksAndTeam, setTasksAndTeam] = useState(() =>
    getFromLocalStorage("selectedTasks", [])
  );
  const [projectDates, setProjectDates] = useState(() =>
    getFromLocalStorage("dateRanges", {})
  );
  const [files, setFiles] = useState(() =>
    getFromLocalStorage("uploadedFiles", [])
  );

  useEffect(() => {
    console.log("Loaded project data:", projectDescription);
    console.log("Loaded tasks and team:", tasksAndTeam);
    console.log("Loaded project dates:", projectDates);
    console.log("Loaded files:", files);
  }, [projectDescription, tasksAndTeam, projectDates, files]);

  return (
    <div className="summary-container">
      <div className="summaryScreen">
        <div className="summary-header-container">
          <h3 className="summary">Summary</h3>
          <div className="summ-container">
            {/* Project Description */}
            <div className="description-container">
              <h3 className="summary-title">Service Call Description</h3>
              <div className="details-container">
                <div className="details-wrapper">
                  <table className="details-table">
                    <thead>
                      <tr>
                        <th>House Details</th>
                        <th>Contact Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td> <strong>Address</strong> <br /> {projectDescription.address || "Not provided"} </td>
                        <td>
                          <strong>Post Code</strong> <br /> {projectDescription.postCode || "Not provided"} </td>
                      </tr>

                      <tr>
                        <td colSpan="2">
                          <h3 className="overview">Project Overview</h3>
                          <p> {projectDescription.serviceCallDescription || "No overview provided"} </p>
                        </td>
                        <td>
                          <strong>Contact Phone</strong>
                          <br />
                          {projectDescription.contactPhone || "Not provided"}
                        </td>
                        <td>
                          <strong>Contact Email</strong>
                          <br />
                          {projectDescription.contactEmail || "Not provided"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Task and Dates */}
            <div className="taskanddates-container">
              <h3 className="summary-title">Task and Dates</h3>
              <div className="details-container">
                <table className="project">
                  <tbody>
                    {tasksAndTeam.map((task, index) => (
                      <React.Fragment key={index}>
                        <tr className="task-title">
                          <td colSpan="2">{task.name || task.taskname}</td>
                        </tr>

                        <tr>
                          <td className="task-details">
                           
                              {(task.subtasklist || []).map((subtask) => (
                                <li key={subtask.value}>{subtask.label}</li>
                              ))}
                          
                          </td>

                          <td className="team-data">
                            {(task.employeelist || []).map(
                              (member, memberIdx) => (
                                <div className="teams" key={memberIdx}>
                                  <span className="employeeName">{member.label}</span>

                                  <span>
                                    {projectDates[task.taskid]?.[memberIdx]
                                      ?.startDate
                                      ? `${new Date(
                                          projectDates[task.taskid][
                                            memberIdx
                                          ].startDate
                                        ).toLocaleDateString()} to ${new Date(
                                          projectDates[task.taskid][
                                            memberIdx
                                          ].endDate
                                        ).toLocaleDateString()}`
                                      : "No date selected"}
                                  </span>

                                  {/* Placeholder for start time */}

                                  <span>
                                    {projectDates[task.taskid][memberIdx]
                                      .startTime || "Time is not Selected"}
                                  </span>
                                  <span>
                                    {projectDates[task.taskid][memberIdx]
                                      .endTime || "Time is not Selected"}
                                  </span>
                                </div>
                              )
                            )}
                          </td>
                        </tr>

                        {/* Horizontal line between categories */}
                        <tr>
                          <td colSpan="2">
                            <hr className="horizontal-line" />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Additional Details */}
            <div className="additionaldetails-container">
              <h3 className="summary-title">Additional Details</h3>

              {/* Attachments Section */}
              <div className="additionaldetails">
                <h3 className="attach">Attachments</h3>
                <div className="file-list">
                  {/* File List */}
                  {files.length > 0 ? (
                    files.map((file, index) => (
                      <div key={index} className="file-item">
                        {/* File Preview */}
                        <img
                          src={file.image || "images/doc.svg"}
                          alt={`${file.name} preview`}
                          className="file-preview"
                        />

                        {/* File Name and Size */}
                        <span className="file-name">{file.name}</span>
                        <span className="file-size">{file.size}</span>
                      </div>
                    ))
                  ) : (
                    // No Files Uploaded Message
                    <p>No files uploaded</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default ServiceSummary;
